<template>
  <pcg-modal
      modal-id="confirm-plan-updates"
      size="sm"
      :btn-title="$t('general.yes')"
      btn-class="w-50"
      scrollable
      :action="save"
  >
    <div class="prk-fz-16 font-weight-bold pcg-the-darkest-gray-color mb-3">
      {{ $t('components.prk_modals.confirm_plan_updates.text') }}
      <prk-table :items="subjectsNames" disable-actions :show-headline="false" />
    </div>
    <template #button-before>
      <pcg-btn
          class="w-50" variant="additional"
          @click="hide"
      >
        {{$t ('general.no') }}
      </pcg-btn>
    </template>
  </pcg-modal>
</template>

<script>
import { mapActions } from 'vuex'
import PrkTable from '../../PrkTable'

export default {
  name: 'ConfirmPlanUpdates',
  components: { PrkTable },
  props: {
    assignedSubjects: { required: true, type: Array },
  },
  computed: {
    subjectsNames () {
      return this.assignedSubjects.map(subject => ({ name: subject.name }))
    },
  },
  methods: {
    ...mapActions('subjects', ['setShowWarning']),
    save () {
      this.setShowWarning(false)
      this.$emit('save')
      this.$bvModal.hide('confirm-plan-updates')
    },
    hide () {
      this.$bvModal.hide('confirm-plan-updates')
    },
  },
}
</script>
